import { getDecodedConsulData } from '@shared/lib/consul'
import { DisabledServiceType } from '../model/tsp.types'

export const fetchIsServiceZeroFeeById = async (id: string) => {
  const data = await getDecodedConsulData<{ zeroFeeServices: DisabledServiceType[] }>(
    '/services/zero-fee-services/value'
  )

  return data.zeroFeeServices.includes(id)
}
